import * as React from "react";
import {Box} from "@unibuddy/patron";

import {BlogPostDetailImageMedia} from "./BlogPostDetailImageMedia";
import {CONTENT_CARD_IMAGE_HEIGHT} from "../../constants";
import {BlogDetailVideoPlayer} from "./BlogDetailVideoPlayer";
import {getContentType} from "../../../../../widgets/modules/Content/utils";
import {ContentType, Post} from "../../../../../widgets/modules/Content/types";

type BlogDetailMediaProps = {
    post: Post;
    autoPlay: boolean;
};

export const BlogDetailMedia = ({post, autoPlay}: BlogDetailMediaProps) => {
    const contentType = getContentType(post);
    const videoContent = post?.videoContent ?? null;
    const coverImages = post?.coverImages ?? [];
    const youtubeVideo = post?.youtubeVideo;
    const title = post?.title ?? "";

    switch (contentType) {
        case ContentType.BLOG:
            if (coverImages.length === 0) {
                return null;
            }

            return (
                <BlogPostDetailImageMedia
                    key={post.id}
                    image={coverImages[0]}
                    title={title}
                    height={CONTENT_CARD_IMAGE_HEIGHT}
                />
            );

        case ContentType.YOUTUBE_VIDEO:
            if (!youtubeVideo) {
                return null;
            }
            return (
                <Box display="flex" justifyContent="center" width="100%">
                    <Box w="500px" h="300px" minH="300px" id="prospect-content-hacked-wrapper">
                        <iframe
                            style={{
                                border: "none",
                            }}
                            width="100%"
                            height="100%"
                            src={`https://www.youtube-nocookie.com/embed/${youtubeVideo}`}
                            title={title}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                        />
                    </Box>
                </Box>
            );

        case ContentType.SHORT_VIDEO:
            return (
                <Box display="flex" justifyContent="center" width="100%">
                    <Box maxW="500px" id="prospect-content-hacked-wrapper">
                        <BlogDetailVideoPlayer
                            style={{maxWidth: "500px", height: "100%", backgroundColor: "white"}}
                            videoUrl={videoContent.url.url}
                            autoPlay={autoPlay}
                        />
                    </Box>
                </Box>
            );

        default:
            return null;
    }
};
